module.exports = __webpack_public_path__ + "img/empty-set-danger.abb619e6.svg";